import { usePage } from "@inertiajs/vue3";

export function useAffiliate() {
    const queryParams = usePage().props.queryParameters as {
        affiliate_uuid?: string;
    };

    if ("affiliate_uuid" in queryParams) {
        document.cookie = `affiliate_uuid=${queryParams.affiliate_uuid}; max-age=864000`;
    }
}
